import axios from 'axios';

export default {
  FETCH_PARENTCORPS ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('corporations/loadCorpParentAcct')
        .then((response) => {
          const { data: { data : { payload } } } = response;
          localStorage.setItem('parentCorps', JSON.stringify(payload));
          console.log('parent corps', payload)
          commit('SET_PARENTCORP', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FILTER_PLAYLISTS ({commit, dispatch}, filterText){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/playlists/searchAlikeTitleVideos/${filterText}`)
        .then((response) => {
          const { data: { data : { payload } } } = response;
          commit('SET_FILTER_RESULTS', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GET_SELECTED_PARENT_CORP ({ commit }, parentAccountId) {
    commit('TOGGLE_LOADING', true);
    return axios.get(`corporations/loadCorpParentAcct`).then((response) => {
      commit('TOGGLE_LOADING', false);
      const { data: { data : { payload }} } = response;
      let selectedParentCorp = payload.filter(x => {
        return x.parentAccountId.toString() === parentAccountId.toString()
      });
      console.log('found parent Corp', selectedParentCorp[0])
      commit('SET_SELECTED_PARENTCORP', selectedParentCorp[0])
    }, (err) => {
      commit('TOGGLE_LOADING', false);
      console.log('err ', err)
    })
  },
  GET_PARENT_CORP_USER_LIST ({ commit }, corpCsv) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`corporations/loadMultipleCorpUsers/${corpCsv}`)
        .then((response) => {
          const { data: { data } } = response;
          commit('SET_PARENT_CORP_USER_LIST', data)
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  ADD_PARENT_CORP({commit, dispatch}, payload){
    payload.csvCorporationIds = payload.csvCorporationIds.toString()
    console.log('add payload', payload)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      console.log("add playlist payload : ", payload);
      axios.post('corporations/addCorpParentAcct', payload)
        .then((response) => {
          console.log('ADD_PARENTCORP action fetch response : ', response);
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('ADD_PARENTCORP action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_PARENT_CORP({commit, dispatch}, payload){
    payload.csvCorporationIds = payload.csvCorporationIds.toString()
    payload.csvParentSuperUserIds = payload.csvParentSuperUserIds.toString()
    console.log('add payload', payload)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      console.log("add playlist payload : ", payload);
      axios.post('corporations/updateCorpParentAcct', payload)
        .then((response) => {
          console.log('UPDATE_PARENTCORP action fetch response : ', response);
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_PARENTCORP action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  // UPDATE_VIDEO_META_DATA({commit, dispatch}, csvVideoCodes){
  //   console.log('new meta data paylaod', csvVideoCodes )
  //   return new Promise((resolve, reject) => {
  //     commit('TOGGLE_LOADING', true);
  //     axios.post('/corporations/updateToneDBWithJWData', {csvVideoCodes: csvVideoCodes} )
  //       .then((response) => {
  //         const { data: { data } } = response;
  //         commit('TOGGLE_LOADING', false);
  //         resolve(data);
  //       })
  //       .catch((error) => {
  //         console.log('UPDATE_PLAYLIST action fetch error : ', error);
  //         reject(error);
  //         commit('TOGGLE_LOADING', false);
  //       });
  //   })
  // },
  UPDATE_PLAYLIST({commit, dispatch}, payload){
    console.log('updaet payload', payload)
    console.log('playload id', payload.playlistId)
    let updatePayload = {
      'playlistId': payload.playlistId,
      'csvCorporationId': payload.csvCorporationId.toString(),
      'playlistTitle': payload.playlistTitle,
      'playlistDescription': payload.playlistDescription,
      'csvVideoCodes': payload.csvVideoCodes,
      'active': payload.active
    }
    console.log('new paylaod', updatePayload)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/playlists/updateCorporationPlaylistWithVideos', updatePayload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_PLAYLIST action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/parentCorporations/actions.js